import styled from "styled-components"
import { animated } from "@react-spring/web"
import { colours } from "../../../ApartmentFinderConfig/colours"
import { Link } from "react-router-dom"

export const UI = styled(animated.div)`
  position: absolute;
  top: ${props => props.right}px;
  right: 0;
  z-index: 1;
  padding-top: 10rem;
  overflow: hidden;
  overflow-y: scroll;
  width: 25vw;
  height: 100%;
  opacity: 0.95;
  background-color: ${colours.primaryUI};
`

export const TempFaves = styled.div`
  display: flex;
  cursor: pointer;
  border-bottom: ${colours.offWhite} solid 1px;
  height: 7vw;
  font-size: 1rem;
  background-color: ${colours.primaryUILighter};
  padding: 0.9vw;
`

export const Block = styled.div`
  width: 30%;
  height: 100%;
  font-family: OuterSans-Regular;
  color: #5f7774;
  font-size: 1vw;
`

export const TitleHolder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  width: 50%;
  height: 100%;
  user-select: none;
  h1 {
    color: #294451;
    font-family: AzoSans-Regular;
    font-size: 1.2vw;
    margin: 0;
    padding: 0;
    line-height: 120%;
  }
  h2 {
    color: #ffffff;
    font-family: OuterSans-Regular;
    font-size: 1.8vw;
    margin: 0;
    padding: 0;
    line-height: 150%;
  }
  h3 {
    color: #000000;
    font-size: 0.9vw;
    font-family: NotoSans-Regular;
    margin: 0;
    padding: 0;
    line-height: 100%;
  }
`

export const SubContent = styled.div`
  width: 20%;
  height: 100%;
`

export const IconHolder = styled.div`
  z-index: 2;
  user-select: none;
  position: absolute;
  cursor: pointer;
  top: 0%;
  right: 0%;
  height: 60px;
  width: 60px;
  margin: 2vw;
  margin-top: 0%;
`
export const GoFavButton = styled(Link)`
  display: ${({ visible }) => (visible ? "block" : "none")};
  position: absolute;
  bottom: 1rem;
  right: 20vw;
  z-index: 2;
  user-select: none;
  cursor: pointer;
  width: 5vw;
  max-width: 5rem;
  height: 5vw;
  max-height: 5rem;
`
